// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"e0902bfc","1429":"59ed6624","8637":"12da12cc"}[chunkId] + ".chunk.css";
};